import { EPermissoes } from '@/enums/ePermissoes';
import type { RouteLocationNormalizedLoaded } from 'vue-router';

export default [
  {
    description: 'Status de Não Conformidade',
    path: '/nao-conformidade/ncostatus',
    alias: '/nao-conformidade/nco-status',
    name: 'ncostatus',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/nco-status/Index.vue'),
    meta: {
      permissions: [EPermissoes.NaoConformidade_Configuracao],
      escopoObra: 'global'
    }
  },
  {
    description: 'Cadastro de Status de Não Conformidade',
    path: '/nao-conformidade/nco-status/cadastro',
    parent: 'ncostatus',
    name: 'ncostatus-insert',
    component: () => import('@/views/nao-conformidade/nco-status/InclusaoEdicao.vue'),
    meta: {
      pageTitle: (route: RouteLocationNormalizedLoaded) => Number(route.query.rac) === 1
        ? 'Cadastro de Status de RAC'
        : 'Cadastro de Status de Não Conformidade',
      parentRouteName: 'ncostatus',
      permissions: [EPermissoes.NaoConformidade_Configuracao]
    }
  },
  {
    description: 'Edição de Status de Não Conformidade',
    path: '/nao-conformidade/nco-status/cadastro/:id',
    parent: 'ncostatus',
    name: 'ncostatus-update',
    component: () => import('@/views/nao-conformidade/nco-status/InclusaoEdicao.vue'),
    meta: {
      pageTitle: (route: RouteLocationNormalizedLoaded) => Number(route.query.rac) === 1
        ? 'Edição de Status de RAC'
        : 'Edição de Status de Não Conformidade',
      parentRouteName: 'ncostatus',
      permissions: [EPermissoes.NaoConformidade_Configuracao]
    }
  }
];
